import { render, staticRenderFns } from "./EncabezadoCard.vue?vue&type=template&id=e06739ea&scoped=true"
import script from "./EncabezadoCard.vue?vue&type=script&lang=js"
export * from "./EncabezadoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06739ea",
  null
  
)

export default component.exports